const loader = (p) => {
    try{
        if(!document.getElementById('loader')){
            if (p) { 
    } else {
        document.getElementById('loader').classList.add('d-none');
    }
        }

    if (p) {
        document.getElementById('loader').classList.remove('d-none');
    } else {
        document.getElementById('loader').classList.add('d-none');
    }
}catch{
    setTimeout(() => {
     if (p) { 
    } else {
        document.getElementById('loader').classList.add('d-none');
    }   
    }, 2000);
}
}

export default loader;